<template>
  <base-modal
    :closeable-from-outside="false"
    hide-footer
    :size="'lg'"
    :modal-id="'flashdeal-add-privilege'"
    @hidden="$emit('onCloseModal')"
    @show="() => {}"
  >
    <div class="content-container">
      <div class="row mb-1">
        <div class="col-12 p-0">
          <div class="d-flex information-header">
            <div class="mr-auto">
              <div>
                Add Privilege
              </div>
            </div>
            <div class="ml-auto">
              <div v-if="tabIndex == pageIndex.INFO_PAGE">Selected : {{ selectedCount }}</div>
              <div v-else>Total : {{ totalCount }}</div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <b-tabs
          v-model="tabIndex"
          class="title-tab-custom"
          content-class="no-tab-title"
        >
          <b-tab
            title="First"
            lazy
          >
            <add-privilege-list-tab
              :privilege-obj="privilegeSelectedList"
              @onSelectedCount="onSelectedCount"
              @onNext="onSelectItemList"
              @onCloseModal="$emit('onCloseModal')"
            />
          </b-tab>
          <b-tab
            title="Second"
            lazy
          >
            <add-privilege-info-tab
              :privilege-obj="privilegeSelectedList"
              @onEdit="$emit('onEdit')"
              @onTotalCount="onTotalCount"
              @onBack="onSelectInventory"
              @onCloseModal="$emit('onCloseModal')"
            />
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </base-modal>
</template>

<script>
import {
  ref,
  reactive,
} from '@vue/composition-api'
import AddPrivilegeListTab from '../components/AddPrivilegeList.vue'
import AddPrivilegeInfoTab from '../components/AddPrivilegeInfo.vue'

import {
  pageIndex
} from "@/configs/privilege/code-template";

export default {
  components: {
    AddPrivilegeListTab,
    AddPrivilegeInfoTab,
  },
  props: {},
  setup() {
    const tabIndex = ref(0);

    const privilegeSelectedList = reactive({
      inventoryObj: null,
      inventoryTableObj: null,
    })

    const selectedCount = ref(0);
    const totalCount = ref(0);

    const onSelectItemList = ({
      inventoryObj,
      inventoryTableObj,
    }) => {
      privilegeSelectedList.inventoryObj = inventoryObj
      privilegeSelectedList.inventoryTableObj = inventoryTableObj
      tabIndex.value++
    }

    const onSelectInventory = () => {
      tabIndex.value--
    }

    const onSelectedCount = count => {
      selectedCount.value = count
    }

    const onTotalCount = count => {
      totalCount.value = count
    }

    return {
      tabIndex,
      privilegeSelectedList,
      selectedCount,
      totalCount,
      onSelectItemList,
      onSelectInventory,
      onSelectedCount,
      onTotalCount,

      pageIndex
    }
  },
}
</script>

<style scoped>
@import '~@/assets/css/pages/default-static-table.css';
@import '~@/assets/css/override-styles/v-select.css';
@import '~@/assets/css/override-styles/dynamic-fields.css';
@import "~@/assets/css/pages/flashdeal/add-privilege-modal.css";
</style>
